import { Link, useLocation } from 'react-router-dom';
import HostingPaywall from './HostingPaywall';
import type { HostedCreditsMode } from '../hostedCredits';

type Props = {
  mode: Exclude<HostedCreditsMode, null>;
};

export default function HostedCreditsCTA({ mode }: Props) {
  const loc = useLocation();
  const next = encodeURIComponent(loc.pathname + loc.search);
  if (mode === 'login') {
    return (
      <div
        data-testid="hosted-credits-cta"
        className="text-xs bg-accent/10 border border-accent/30 rounded-md px-3 py-2.5 text-textp"
      >
        <div className="font-medium">Sign in to use hosted models</div>
        <p className="text-texts mt-1 leading-relaxed">
          New accounts get 20 free hosted runs. Local models and your own keys stay free.
        </p>
        <Link
          to={`/login?next=${next}`}
          className="mt-2 inline-flex items-center gap-1 text-accent hover:text-accent-hover font-medium"
        >
          Sign in
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    );
  }
  return (
    <div data-testid="hosted-credits-cta">
      <HostingPaywall />
    </div>
  );
}
